import React, { useState, useEffect } from "react";
import {
    Modal,
    Button,
    Form,
    FormGroup,
    FormControl,
    ControlLabel,
    Col,
    Row,
} from "react-bootstrap";
import './style.css';
import AddEditBillCategoryModal from "./AddEditBillCategory";
import Select from "react-select";
import * as API from '../../../api/billing'
import { useSelector, useDispatch } from "react-redux";
import * as actionTypes from "Front/actions/actionTypes";

const AddEditService = ({ show, onHide, row = {}, categories = [], setCategories, handleToastifyMessage }) => {
    const [formData, setFormData] = useState({ category: "", service: "", price: "", description: "" });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [serviceId, setServiceId] = useState("");
    const [mode, setMode] = useState("add");
    const [openCategoryModal, setOpenCategoryModal] = useState(false)
    const [categoryOptions, setCategoryOptions] = useState([])
    const billingReduxData = useSelector((store) => store.billing);
    const dispatch = useDispatch()

    useEffect(() => {
        if (!row?._id) return;

        const { name = "", price = "", categoryId = {}, _id, description } = row;
        const selectedCategory = categoryOptions.find(cat => cat?.value === categoryId?._id);
        setFormData({
            category: selectedCategory || null,
            service: name,
            price: price,
            description: description
        });

        setServiceId(_id);
        setMode("edit");
    }, [row, categoryOptions]);

    const inputHandler = (e) => {
        const { name, value } = e.target;
        const cleanedValue =
            name === "name" || name === "description"
                ? value.replace(/\s+/g, " ").trimStart()
                : value;

        setFormData((prev) => ({
            ...prev,
            [name]: cleanedValue,
        }));
    };


    const validate = () => {
        const err = {};
        let isValid = true;
        if (!formData.category) {
            err.category = "error";
            isValid = false;
        }
        if (!formData.service) {
            err.service = "error";
            isValid = false;
        }
        if (!formData.price) {
            err.price = "error";
            isValid = false;
        }

        setErrors(err);
        if (!isValid)
            setIsLoading(false)
        return isValid;
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (validate()) {


            const sentData = new FormData();
            sentData.append("categoryId", formData.category.value);
            sentData.append("name", formData.service);
            sentData.append("price", parseFloat(formData.price));
            sentData.append("description", formData.description)

            let resp;
            if (mode === "add") {
                resp = await API.addService(sentData);
            } else {
                sentData.append("id", serviceId);
                resp = await API.updateService(sentData);
            }
            if (resp?.data?.statusCode === 200 && resp.data.status === "Success") {
                if (mode === "edit") {
                    const allSubCategories = billingReduxData?.billSubCategoryList
                    if (allSubCategories?.length) {
                        const updatedSubCategories = allSubCategories.map(subCat => {
                            if (subCat?._id === serviceId) {
                                return {
                                    ...subCat,
                                    name: formData.service,
                                    price: parseFloat(formData.price),
                                    description: formData.description
                                };
                            }
                            return subCat;
                        });
                        dispatch({
                            type: actionTypes.SET_ALL_BILL_SUB_CATEGORY_LIST,
                            payload: updatedSubCategories,
                        });
                    }
                } else if (mode === "add") {
                    const allSubCategories = billingReduxData?.billSubCategoryList || [];
                    const createdService = {
                        _id: resp?.data?.data?.id,
                        name: formData.service,
                        price: parseFloat(formData.price),
                        description: formData.description || "",
                        categoryId: {
                            _id: formData?.category?.value,
                            name: formData?.category?.label,
                            isActive: true
                        },
                        isActive: true,
                        systemDefault: false,
                        systemDefaultName: ""
                    };
                    dispatch({
                        type: actionTypes.SET_ALL_BILL_SUB_CATEGORY_LIST,
                        payload: [...allSubCategories, createdService],
                    });
                }
                setIsLoading(false);
                handleToastifyMessage(mode)
                onHide(true);
            }
        } else {
            setIsLoading(false);
        }
    };

    const onHideCategoryModal = () => setOpenCategoryModal(false)

    const onAddCategory = (category = {}) => {
        setFormData({ ...formData, category: { label: category?.name, value: category?._id } })
        setCategories([category, ...categories]);
    }

    useEffect(() => {
        const options = categories.map(cat => ({
            value: cat._id,
            label: cat.name
        }));
        setCategoryOptions([...options])

    }, [categories])


    return (
        <>
            <Modal show={show} onHide={onHide} dialogClassName="modal-md modal-dialog-centered">
                <Modal.Header closeButton className="bg-thumbcolor">
                    <Modal.Title>{mode === "add" ? "Add Service" : "Edit Service"}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="body-parts">
                    <Form horizontal>
                        <FormGroup>
                            <Col sm={12}>
                                {/* HEADER with ADD CATEGORY BUTTON */}
                                {!row?._id &&
                                    <Row className="d-flex justify-content-between align-items-center" style={{ marginBottom: "10px" }}>
                                        <Col md={6}>

                                        </Col>
                                        <Col md={6} className="text-end">
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                style={{ float: "right", fontSize: "13px", padding: "4px 10px", borderRadius: "5px" }}
                                                onClick={() => setOpenCategoryModal(true)}
                                                className="btn-fill btn-primary"
                                            >
                                                <i className="fa fa-plus" style={{ marginRight: "4px" }}></i>
                                                Add Category
                                            </Button>
                                        </Col>
                                    </Row>
                                }

                                {/* CATEGORY DROPDOWN */}
                                <div style={{ marginBottom: "10px" }}>
                                    <Select
                                        disabled={row?.systemDefault || false}
                                        options={categoryOptions}
                                        value={formData.category}
                                        onChange={(selected) => {
                                            setFormData({ ...formData, category: selected });
                                        }}
                                        isClearable
                                        isSearchable
                                        classNamePrefix="react-select"
                                        className={`react-select-container ${errors.category ? 'select-error' : ''}`}
                                        styles={{
                                            container: (base) => ({
                                                ...base,
                                                marginBottom: 10,
                                                border: errors.category ? "1px solid red" : undefined,
                                            }),
                                            control: (base, state) => ({
                                                ...base,
                                                borderColor: errors.category ? "red" : base.borderColor,
                                                boxShadow: errors.category ? "0 0 0 1px red" : base.boxShadow,
                                                "&:hover": {
                                                    borderColor: errors.category ? "red" : base.borderColor,
                                                },
                                            }),
                                        }}
                                    />
                                    {errors.category && (
                                        <span style={{ color: "red", fontSize: "12px", marginTop: "-6px" }}>
                                            Category is required
                                        </span>
                                    )}
                                </div>



                                {/* SERVICE TEXTBOX */}
                                <FormControl
                                    type="text"
                                    name="service"
                                    placeholder="Service"
                                    autoComplete="off"
                                    value={formData.service}
                                    onChange={inputHandler}
                                    className={`form-control mb-3 ${errors.service || ""}`}
                                    style={{ marginBottom: "10px" }}
                                />

                                <FormControl
                                    as="textarea"
                                    rows={4} // Optional: number of visible rows
                                    name="description"
                                    placeholder="description"
                                    autoComplete="off"
                                    value={formData.description}
                                    onChange={inputHandler}
                                    className={`form-control mb-2 ${errors.description || ""}`}
                                    style={{ marginBottom: "10px" }}
                                />

                                {/* CHARGE TEXTBOX */}
                                <FormControl
                                    type="text"
                                    name="price"
                                    placeholder="Enter price"
                                    autoComplete="off"
                                    value={formData.price}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        // Allow only digits and max one dot
                                        const validPattern = /^\d*\.?\d*$/;

                                        if (value === '' || validPattern.test(value)) {
                                            inputHandler(e);
                                            setErrors((prev) => ({
                                                ...prev,
                                                price: "",
                                            }));
                                        } else {
                                            setErrors((prev) => ({
                                                ...prev,
                                                price: "Only numbers with one decimal point allowed",
                                            }));
                                        }
                                    }}
                                    className={`form-control mb-3 ${errors.price || ""}`}
                                    style={{ marginBottom: "10px" }}
                                    inputMode="decimal"
                                />
                            </Col>
                        </FormGroup>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        style={{ borderRadius: "5px" }}
                        className="btn-fill btn-primary"
                        onClick={submitHandler}
                        disabled={isLoading || errors?.length}
                    >
                        {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Save"}
                    </Button>
                </Modal.Footer>
            </Modal>
            {openCategoryModal &&
                <AddEditBillCategoryModal
                    show={openCategoryModal}
                    onHide={onHideCategoryModal}
                    row={null}
                    isCategoryAddedFromAddOnService={true}
                    onAddCategory={onAddCategory}
                />
            }
        </>
    );
};

export default AddEditService;
